var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.48,
    height: 26.043,
    viewBox: "0 0 37.48 26.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31891",
    x: 0,
    y: 0,
    width: 37.48,
    height: 26.043,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DA-_Flag",
    "data-name": "DA- Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31891-2",
    "data-name": "Rectangle 31891",
    width: 34.48,
    height: 23.043,
    transform: "translate(1.5 0.5)",
    fill: "#bc0226"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40602",
    "data-name": "Path 40602",
    d: "M11.179,0V9.875H0v3.292H11.179v9.875H14.9V13.168H34.466V9.875H14.9V0Z",
    transform: "translate(0.007 0.002)",
    fill: "#fffaff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaFlag);
export default __webpack_public_path__ + "static/media/DA- Flag.9260cc874dc52e8d43fe3db712ca38ac.svg";
export { ForwardRef as ReactComponent };